export enum ReportApiRoutesEnum {
  ReportByGrades = 0,
  ReportByStudent = 1,
  ReportMap = 2,
  ReportTct = 3,
  AttemptStudents = 4,
  AnswerStudents = 5,
  ReportCard = 6,
  ReportByQuestion = 7,
  ReportMapAll = 8,
}
